<template>
  <div class="select-company">
    <div class="el-icon-back back" @click="back"><span>选择企业</span></div>
    <div class="main" v-ps>
      <div class="company-list">
        <div class="company-item" v-for="company in companies" :key="company.id">
          <img :src="company.logo ? company.logo : defaultLogo" />
          <div class="company-name" v-tip>
            {{ company.name }}
          </div>
          <base-button class="go-button" type="default" @click="setCurCompany(company)">
            前往
          </base-button>
        </div>
        <div class="company-item pointer" @click="showAddCompany">
          <div class="add-company">
            <svg-icon icon-class="plus"></svg-icon>
          </div>
          <div class="font-txt">加入/创建企业</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as companyApi from "@/api/userCenter/company"
import BaseButton from "@/components/UIComponents/Button"
import { getUnreadMessageCount } from "@/api/userCenter/message"
import { setUnreadMessageCount } from "@/store/actions"
import { defaultLogo } from "~/data/static"

export default {
  name: "select-company",
  components: { BaseButton },
  data() {
    return {
      loading: false,
      defaultLogo,
      companies: []
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.loading = true
      companyApi.getCurUserCompanies().then(res => {
        this.companies = res.data
        this.loading = false
      })
    },
    showAddCompany() {
      this.$router.push({ path: "/createOrJoin" })
    },
    back() {
      this.$router.go(-1)
    },
    setCurCompany(company) {
      companyApi.setCurCompany(company.id).then(res => {
        this.$message.success("设置成功")
        this.$router.replace({ name: "home" })
        getUnreadMessageCount().then(count => {
          setUnreadMessageCount(count)
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.select-company {
  height: 100vh;
  width: 100%;
  background: #f5f5f5;
  .back {
    position: fixed;
    z-index: 10;
    left: 40px;
    top: 48px;
    font-size: 18px;
    color: #606266;
    line-height: 28px;
    cursor: pointer;
    span {
      margin-left: 5px;
    }
  }
  .main {
    width: 100vw;
    height: 100vh;
    .company-list {
      width: 448px;
      min-height: 100%;
      padding: 60px 0;
      box-sizing: border-box;
      margin: auto;
      display: flex;
      flex-flow: column;
      justify-content: center;
      .company-item {
        display: flex;
        align-items: center;
        box-sizing: border-box;
        flex-shrink: 0;
        height: 70px;
        padding: 0 24px;
        background: #ffffff;
        border-radius: 10px;
        margin-bottom: 10px;
        &:hover {
          box-shadow: 0 2px 10px 4px rgba(192, 196, 204, 0.3);
        }
        img {
          border-radius: 9px;
          border: 1px solid #dcdfe6;
          width: 40px;
          height: 40px;
          margin-right: 12px;
        }
        .company-name {
          color: #606266;
          font-size: 14px;
          flex: 1;
        }
        .go-button {
        }
        .add-company {
          width: 40px;
          height: 40px;
          @include flex-center;
          background: rgba(234, 236, 241, 1);
          border-radius: 6px;
          text-align: center;
          margin-right: 12px;
          .svg-icon {
            font-size: 24px;
            color: #ffffff;
          }
        }
        .font-txt {
          flex: auto;
          font-size: 16px;
          font-weight: 400;
          color: #c0c4cc;
          line-height: 22px;
        }
      }
    }
  }
}
</style>
